import { ApiService, toModel } from '~/shared/api'
import { AgrocityModel } from '~/models/agrocity'
import { API_PREFIX } from '~/shared/const/request-services'
import { PaginationDataModel } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'
import { mapToModels } from '~/shared/utils/response'
import type { Paginated, UnknownObject } from '~/shared/interfaces'

export class AgrocityService extends ApiService {
  protected route: string = `${API_PREFIX}/agrocities/get`

  getList(params?: UnknownObject): Promise<Paginated<AgrocityModel>> {
    return this.http.request({ url: `${this.route}/query`, params }).then(res => {
      const body = isUnknownObject(res.data) ? res.data : {}

      return {
        models: mapToModels(body.data, AgrocityModel),
        pagination: new PaginationDataModel(body.meta),
      }
    })
  }

  getItem(slug: string): Promise<AgrocityModel> {
    return this.http.request({ url: `${this.route}/${slug}` }).then(toModel(AgrocityModel))
  }
}
